import { Injectable } from '@angular/core';
import {BaseService} from "./base.service";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class VardaService extends BaseService {

  private API_VARDA_URL = this.API_BASE_URL + "varda";
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  getVardaBoundaries(latlng) {
    let params = new HttpParams()
      .set('lat', latlng.lng)
      .append('lng', latlng.lat);

    console.log("AGRI")

    return this.httpClient.get<any>(this.API_VARDA_URL + "/boundary", {params});
  }
}
